import { render } from "./AccountPrivacyPage.vue?vue&type=template&id=7396b321&ts=true"
import script from "./AccountPrivacyPage.vue?vue&type=script&lang=ts"
export * from "./AccountPrivacyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__